import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Section, Eyebrow, Heading } from '../Section';
import { CTAButton } from '../CTAButton';
const before = ['Improvising estimates.', 'Guessing your prices.', 'Searching for paperwork.', 'Handling every customer differently.', 'Working longer hours.', 'Wondering why you’re not growing.'];
const after = ['Organize your business.', 'Charge with confidence.', 'Deliver a professional experience.', 'Create repeat customers.', 'Build systems, not improvisation.', 'Grow like a real business owner.'];
export function TwoChoices() {
  return <Section tone="dark" data-id="element-291" data-mp="3aic4bcjdsc91">
      <Eyebrow data-id="element-292" data-mp="3al81uzrbgywy">🚀 You have two choices</Eyebrow>
      <Heading data-id="element-293" data-mp="3fhf9qy39wkhj">Before or after Technical System PRO 360™</Heading>

      <div className="mt-8 grid grid-cols-2 gap-3 sm:gap-5" data-id="element-294" data-mp="3fk1demn1mfuh">
        <div className="flex flex-col overflow-hidden rounded-2xl border border-red-500/30 bg-red-950/25" data-id="element-295" data-mp="1z2domptp6ryu">
          <div className="bg-red-500/90 px-3 py-2.5 text-center" data-id="element-296" data-mp="244ct6316buxd">
            <p className="font-display text-[15px] font-extrabold uppercase tracking-[0.1em] text-white sm:text-xl" data-id="element-297" data-mp="3karcom6f7763">
              Before
            </p>
          </div>
          <ul className="flex flex-1 flex-col gap-2.5 px-3 py-4 sm:px-4" data-id="element-298" data-mp="3u9qh1sk5kgna">
            {before.map(item => <li key={item} className="flex items-start gap-2" data-id="element-299" data-mp="3pa48hwf9rokt">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-300" data-mp="3pd05nijam987" />
                <span className="text-[12.5px] leading-snug text-white/85 sm:text-base" data-id="element-301" data-mp="26pnpkcbu7u9">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="flex flex-col overflow-hidden rounded-2xl border border-green-500/40 bg-green-950/25" data-id="element-302" data-mp="bvhcxkq06e1h">
          <div className="bg-green-500 px-3 py-2.5 text-center" data-id="element-303" data-mp="pwjyzxgzzoce">
            <p className="font-display text-[15px] font-extrabold uppercase tracking-[0.1em] text-navy-950 sm:text-xl" data-id="element-304" data-mp="lu6wrj1gm8kd">
              After
            </p>
          </div>
          <ul className="flex flex-1 flex-col gap-2.5 px-3 py-4 sm:px-4" data-id="element-305" data-mp="sv0on68sp642">
            {after.map(item => <li key={item} className="flex items-start gap-2" data-id="element-306" data-mp="xtvir4c7qh3h">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-400" aria-hidden="true" data-id="element-307" data-mp="12tq8h4k950my" />
                <span className="text-[12.5px] leading-snug text-white/85 sm:text-base" data-id="element-308" data-mp="1bnv0vsf1ak4l">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mt-6 text-center text-[15px] leading-relaxed text-white/80 sm:text-lg" data-id="element-309" data-mp="1ll9ap96gcanx">
        You can keep operating the same way you’ve been operating… or you can
        install a complete operating system designed specifically for appliance
        repair technicians.
      </p>

      <div className="mt-8" data-id="element-310" data-mp="3sbyv1xwyoncj">
        <CTAButton label="I choose the professional path" data-id="element-311" data-mp="3sda3ib1cqj9z" />
      </div>
    </Section>;
}